import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
export class TranslationService {
    constructor(translate) {
        this.translate = translate;
    }
    async get(key, interpolateParams) {
        return new Promise((resolve, reject) => {
            this.translate.get(key, interpolateParams).subscribe((translateValue) => resolve(translateValue), reject);
        });
    }
}
TranslationService.ɵfac = function TranslationService_Factory(t) { return new (t || TranslationService)(i0.ɵɵinject(i1.TranslateService)); };
TranslationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TranslationService, factory: TranslationService.ɵfac, providedIn: 'root' });
